import React, { ComponentProps, CSSProperties, useState } from "react";
import { Image } from "react-bootstrap";

import "./HyperBalance.scss";
import HyperCoin from "../../HyperCoin/HyperCoin";
import ImageAddIcon from "../../../images/add-icon.svg";
import HprInfoModal from "../modals/HprInfoModal/HprInfoModal";
import { formatHprBalance } from "../../../utils/helpers";
import { CustomSpinner } from "../../CustomSpinner/CustomSpinner";
import useAuth from "../../../hooks/useAuth";
import TopupFlow from "../../topup/TopupFlow/TopupFlow";
import useTopupFlow from "../../../hooks/useTopupFlow";
import { useSetAtom } from "jotai";
import {
  initiateTopupTriggerAtom,
  InitiateTopupTriggers,
} from "../../../jotai/atoms/analytics";
import useHprFiatFormatter from "../../../hooks/useHprFiatFormatter";

interface HyperBalanceProps extends ComponentProps<"button"> {
  balance?: number;
  isLoading?: boolean;
  topUpBtnStyle?: CSSProperties;
}
interface BalanceContent {
  isLoading?: boolean;
  balance?: number;
  isHpr?: boolean;
}

export function renderBalanceContent({
  isLoading,
  balance,
  isHpr,
}: BalanceContent) {
  if (isLoading) return <CustomSpinner size="sm" />;
  if (balance === undefined) return "--";
  return isHpr ? formatHprBalance(balance) : balance;
}

function HyperBalance({
  balance,
  isLoading,
  style,
  topUpBtnStyle,
  ...restProps
}: HyperBalanceProps) {
  const [showInfoModal, setShowInfoModal] = useState(false);
  const { isLoggedIn } = useAuth();
  const setInitiateTopupTrigger = useSetAtom(initiateTopupTriggerAtom);
  const {
    modalsProps,
    ipLocationCountry,
    handleTopup,
    handleGetDeviceLocationInfo,
  } = useTopupFlow();

  const { isFiatDisplay, formatHprToFiatValue } = useHprFiatFormatter();

  const displayValue = formatHprToFiatValue(balance);

  const onHide = () => setShowInfoModal(false);
  const onOpen = () => setShowInfoModal(true);

  const canShowTopUpLink = isLoggedIn;

  const goToTopup = () => {
    setInitiateTopupTrigger(InitiateTopupTriggers.HPR_BALANCE_CONTAINER);
    handleTopup();
  };
  const handleBalanceClick = () => {
    if (!isFiatDisplay) {
      onOpen();
    }
  };

  return (
    <>
      <div className="hyper-balance-container">
        <button
          className="hyper-balance-btn"
          onClick={handleBalanceClick}
          style={{
            ...style,
            paddingRight: canShowTopUpLink ? undefined : 6,
            cursor: isFiatDisplay ? "default" : "pointer",
            pointerEvents: isFiatDisplay ? "none" : "auto",
          }}
          {...restProps}
        >
          {!isFiatDisplay && <HyperCoin width="20px" height="20px" />}
          <span>{isLoading ? <CustomSpinner size="sm" /> : displayValue}</span>
        </button>
        {canShowTopUpLink && (
          <button
            className="topup-btn center-content"
            aria-label="topup HPR"
            onClick={goToTopup}
            style={topUpBtnStyle}
          >
            <Image src={ImageAddIcon} alt="add" />
          </button>
        )}

        <HprInfoModal
          show={showInfoModal}
          onHide={onHide}
          balance={balance}
          handleTopup={handleTopup}
        />
      </div>
      <TopupFlow
        {...modalsProps}
        handleTopup={handleTopup}
        ipLocationCountry={ipLocationCountry}
        handleGetDeviceLocationInfo={handleGetDeviceLocationInfo}
      />
    </>
  );
}

export default HyperBalance;
